import { Action } from "redux";
import { OrganizationKeyName } from "../../../model/Organization";

export const DELETE_VENUE_IMAGE_SUCCESS = "VENUE:DELETE_VENUE_IMAGE_SUCCESS";

export interface DeleteVenueImageSuccessAction extends Action {
  type: typeof DELETE_VENUE_IMAGE_SUCCESS;
  organization: OrganizationKeyName;
  id: number;
  imageUrl: string;
}

export const deleteVenueImageSuccessAction = (
  organization: OrganizationKeyName,
  id: number,
  imageUrl: string
): DeleteVenueImageSuccessAction => ({
  type: DELETE_VENUE_IMAGE_SUCCESS,
  organization,
  id,
  imageUrl,
});
